import * as React from 'react';
import VoxelTrendChip from '../../../components/voxel/Chips/VoxelTrendChip';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { formatNumber } from '../../../logic/otherUtilities/formatting/formatNumber';

export interface ProgressDashboardMiniatureKPIProps {
  value?: number;
  valueChange?: number;
  suffix?: string;
  prefix?: string;
  loadingPlaceholder: boolean;
}

const customFormatter = (value?: number): string => {
  if (value !== 0 && !value) return '';
  const magnitude = value.toString().split('.')[0].length;
  if (magnitude > 6) {
    return formatNumber(value / Math.pow(10, 6)) + 'M';
  }
  if (magnitude > 3) {
    return formatNumber(value / Math.pow(10, 3)) + 'k';
  }
  if (magnitude > 0) {
    return formatNumber(value);
  }

  return formatNumber(value, 2);
};

const ProgressDashboardMiniatureKPI: React.FC<ProgressDashboardMiniatureKPIProps> = ({
  value,
  valueChange,
  prefix = '',
  suffix = '',
  loadingPlaceholder,
}) => {
  const formatter = customFormatter;
  if (loadingPlaceholder) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-8 h-6 bg-gray-200/50 rounded animate-pulse" />
        <div className="w-8 h-6 bg-gray-200/50 rounded animate-pulse" />
      </div>
    );
  }
  return (
    <div className="flex flex-row items-center gap-4">
      <VoxelText variant="title2" userSelectClass="none">
        {value ? prefix + formatter(value) + suffix : '-'}
      </VoxelText>
      <VoxelTrendChip
        size="sm"
        title={`${valueChange > 0 ? '+' : valueChange < 0 ? '-' : ''}${
          valueChange ? prefix + formatter(Math.abs(valueChange)) + suffix : '0'
        }`}
        color={valueChange > 0 ? 'success' : valueChange < 0 ? 'error' : 'neutral'}
      />
    </div>
  );
};

export default ProgressDashboardMiniatureKPI;
